module.exports = __webpack_public_path__ + "static/media/qrcode.75f40b32.jpeg";